import styled from "styled-components";
import { motion } from "framer-motion";
import photo from "assets/images/Suyane_Mike_HickDuarte_34361.jpg";

export const Container = styled.div`
  width: 100%;
  height: 100%;
  margin: 0 auto;
  display: flex;
  position: relative;
  background-color: #010822;
  min-height: 100vh;
`;

export const PhotoWrapper = styled.div`
  width: 100%;
  max-width: 621px;
  height: 100vh;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  position: relative;
  margin: 0 auto;
  overflow: hidden;

  @media screen and (max-width: 768px) {
    max-width: 100%;
  }
`;

export const Photo = styled(motion.div)`
  width: 100%;
  height: 100vh;
  background: url(${photo}) no-repeat center center;
  background-size: contain;
  margin: 0 auto;

  @media screen and (max-width: 768px) {
    background-size: cover;
  }
`;

export const Text = styled.article`
  width: 100%;
  max-width: 150px;
  color: rgba(255, 255, 255, 0.8);
  font-size: 14px;
  line-height: 20px;
  position: absolute;
  bottom: 96px;
  right: 72px;
  z-index: 99;

  @media screen and (max-width: 414px) {
    max-width: 120px;
    font-size: 10px;
    line-height: 16px;
    bottom: 72px;
    right: 32px;
  }
`;
